import { render, staticRenderFns } from "./InformeSitio.vue?vue&type=template&id=1e412364&scoped=true&"
import script from "./InformeSitio.vue?vue&type=script&lang=ts&"
export * from "./InformeSitio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e412364",
  null
  
)

export default component.exports